if (module.hot) {
  module.hot.accept();
}
